/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type SuspectedTradeUserLoader_itemSearch$ref = any;
export type SuspectedTradeUserLoader_itemSearch = {
    readonly topCategoryL1: VerticalType | null;
    readonly " $refType": SuspectedTradeUserLoader_itemSearch$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SuspectedTradeUserLoader_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "topCategoryL1",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'dd1ea83a88234e46adaa0f0099c529a2';
export default node;
